import React, { useEffect, useState } from "react";
import Sidebar from "../../../Components/Sidebar/Sidebar";
import { Navbar3 } from "../../../Components/Navbar/Navbar";

import { Route, Routes, useNavigate } from "react-router-dom";
import { useAuth } from "../../../Providers/Auth";
import { ShareProfile } from "./ShareProfile/ShareProfile";
import { Dashboard } from "./Dashboard/Dashboard";
import { Company_list } from "./CompanyList/CompanyList";
import { Show_Company_List } from "./CompanyList/ShowCompany";
import UserInfo from "../UserInfo/UserInfo";
import OtpVerify from "../OtpVerify";
import ProtectedRoute from "../../../Helpers/ProtectedRoute";
import { IoIosArrowRoundForward } from "react-icons/io";
import mixpanel from "mixpanel-browser";
import { useGeneralSettings } from "../../../Providers/General";
import { BrandDeals } from "./BrandDeals/BrandDeals";
import { Analytics } from "./Analytics/Analytics";
import { BoostVisibility } from "./BoostVisibility/BoostVisibility";
import { BrandCollabs } from "./BrandCollabs/BrandCollabs";
import { BrandCollabsDetails } from "./BrandCollabs/BrandCollabsDetails";
import { InfluencerFeed } from "./Feed/Feed";
import { FollowOtherCreators } from "./MyNetwork/Follow";
// import { PlatformsIntegration } from "./Platforms/Platforms";
// import { YoutubeAnalyticsProfile } from "./Platforms/Youtube";
// import { TwitterAnalyticsProfile } from "./Platforms/Twitter";
// import { InstagramAnalyticsProfile } from "./Platforms/Instagram";
import InfluencerTools from "./Tools/CreatorTools";
// import { LinkedinAIExtV2 } from "./Platforms/Linkedin";
import { EditMediaKit } from "@/Pages/Influencer/EditMediaKit/EditMediaKit";
import BuildProfile from "./BuildProfile/BuildProfile";
import { PostPerformance } from "./PostPerformance/PostPerformance";
import { YearWrap2024 } from "./YearWrap2024/YearWrap2024";

import { EarningWallet } from "./EarningWallet/EarningWallet";
import InfluencerActivatePage from "./activation/activate-profile";
import InfluencerActivationSuccessPage from "./activation/activate-success";
import WomenDayCard3DViewer from "./WomenDay2025/WomenDay2025";
import { dateDifference } from "@/Helpers/times-ago";
import { SyncAccountPopup } from "@/Components/influencer/popups/SyncAlertPopop";
import HelpUsPage from "@/Pages/Influencer/HelpUs/HelpUs";
import HelpUsAlert from "@/Components/influencer/RibbonAlerts/HelpUsAlert";
import InfluencerBankDetailsForm from "./PaymentDetails/PaymentDetails";
const Home: React.FC = () => {
  const generalState = useGeneralSettings();
  const authState = useAuth();
  const navigate = useNavigate();
  const [showSyncAlert, setShowSyncAlert] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("UserType") === "Brand") {
      window.open("/", "_self");
    }

    const timer = setTimeout(() => {
      setShowSyncAlert(true);
    }, 5000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("UserType")]);

  if (!authState?.loggedUser) {
    generalState?.setDashboardLoading(true);
    return <div></div>;
  } else {
    generalState?.setDashboardLoading(false);
  }

  return (
    <>
      {
        authState?.loggedUser?.status === 0 ||
        !authState?.loggedUser?.is_verified ? (
          <Routes>
            {/* <Route path="/" element={<ProtectedRoute navigateCondition={!authState?.loggedUser?.is_verified} toUrl={"/influencer/userinfo"}><Waitlist /></ProtectedRoute>} /> */}
            <Route
              path="*"
              element={
                <ProtectedRoute
                  navigateCondition={authState?.loggedUser?.is_verified}
                  toUrl={"/influencer/dashboard"}
                >
                  <UserInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/otp-verify"
              element={
                <ProtectedRoute
                  navigateCondition={authState?.loggedUser?.is_verified}
                  toUrl={"/influencer/dashboard"}
                >
                  <OtpVerify />
                </ProtectedRoute>
              }
            />
            <Route path="/edit" element={<EditMediaKit />} />
          </Routes>
        ) : (
          //  window.screen.width > 600 ? (
          <div className="w-screen h-screen flex flex-col items-start overflow-hidden">
            {showSyncAlert &&
              !window.location.pathname.includes("/influencer/wrapped2024") && (
                <HelpUsAlert />
              )}

            {(!authState?.loggedUser?.extensionUsage?.lastSyncTime ||
              (authState?.loggedUser?.extensionUsage?.lastSyncTime &&
                dateDifference(
                  new Date(authState?.loggedUser?.extensionUsage?.lastSyncTime),
                  new Date(Date.now())
                )?.days > 14)) && (
              <SyncAccountPopup
                onSync={() => navigate("/influencer/plugin/sync-profile")}
                onDismiss={function (): void {
                  throw new Error("Function not implemented.");
                }}
              />
            )}

            {/* plan top info bar ----- */}
            {!authState?.loggedUser?.activePlan && (
              <div className="w-screen hidden md:flex items-center justify-center bg-[#000080] text-[#EEEEEE] text-sm py-2 gap-10">
                Your profile is saved but hidden from brands. Publish it now to
                make it visible to brands for potential collaborations.
                <span
                  className="flex items-center gap-2 text-[#F5F5F5] px-3 py-1 bg-[#FF5C5C] rounded-[100px] cursor-pointer"
                  onClick={() => {
                    mixpanel.track("Make Me Visible Collab");
                    navigate("/influencer/payment");
                  }}
                >
                  Make Me Visible <IoIosArrowRoundForward />
                </span>
              </div>
            )}

            <section className="w-full h-full flex items-start overflow-hidden">
              {!window.location.pathname.includes(
                "/influencer/brandCollabs/details/"
              ) &&
                !window.location.pathname.includes("/influencer/edit") && (
                  <Sidebar />
                )}

              <section className="w-full h-full flex flex-col items-center ">
                {!window.location.pathname.includes(
                  "/influencer/brandCollabs/details/"
                ) &&
                  !window.location.pathname.includes("/influencer/edit") && (
                    <Navbar3
                      profile={authState?.loggedUser?.profile}
                      chips={authState?.loggedUser?.totalChips}
                      topCreatorChips={
                        authState?.loggedUser?.featuredData?.topCreatorChips
                        //  ===
                        // authState?.loggedUser?.totalChips
                        //   ? authState?.loggedUser?.featuredData?.topCreatorChips +
                        //     50 +
                        //     new Date().getHours()
                        //   : authState?.loggedUser?.featuredData?.topCreatorChips
                      }
                    />
                  )}

                <div className="bg-[#171717] w-full h-screen overflow-x-hidden overflow-y-auto">
                  {/* {!window.location.pathname.includes(
                    "/influencer/anchorWomans"
                  ) && <YearWrapAlert />} */}
                  <Routes>
                    {!authState?.loggedUser?.slug ? (
                      <>
                        <Route path="*" element={<BuildProfile />} />
                        <Route
                          path="/payment"
                          element={
                            <ProtectedRoute
                              navigateCondition={
                                authState?.loggedUser?.activePlan
                              }
                              toUrl="/influencer/dashboard"
                            >
                              <InfluencerActivatePage />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/share_profile"
                          element={
                            <ProtectedRoute
                              navigateCondition={
                                !authState?.loggedUser?.activePlan
                              }
                              toUrl="/influencer/payment"
                            >
                              <ShareProfile />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/activationSuccess"
                          element={
                            <ProtectedRoute
                              navigateCondition={
                                !authState?.loggedUser?.activePlan
                              }
                              toUrl="/influencer/payment"
                            >
                              <InfluencerActivationSuccessPage />
                            </ProtectedRoute>
                          }
                        />
                        <Route path="/edit" element={<EditMediaKit />} />
                      </>
                    ) : (
                      <>
                        <Route path="*" element={<Dashboard />} />
                        <Route
                          path="/build_profile"
                          element={<BuildProfile />}
                        />
                        <Route
                          path="/share_profile"
                          element={
                            <ProtectedRoute
                              navigateCondition={
                                !authState?.loggedUser?.activePlan
                              }
                              toUrl="/influencer/payment"
                            >
                              <ShareProfile />
                            </ProtectedRoute>
                          }
                        />
                        {/* ----------- feed for influencer ----------- */}
                        <Route path="/feed" element={<InfluencerFeed />} />
                        <Route
                          path="/network"
                          element={
                            <FollowOtherCreators
                              handleSubmit={function (): Promise<void> {
                                throw new Error("Function not implemented.");
                              }}
                            />
                          }
                        />

                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route
                          path="/payment"
                          element={
                            <ProtectedRoute
                              navigateCondition={
                                authState?.loggedUser?.activePlan
                              }
                              toUrl="/influencer/dashboard"
                            >
                              <InfluencerActivatePage />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/activationSuccess"
                          element={
                            <ProtectedRoute
                              navigateCondition={
                                !authState?.loggedUser?.activePlan
                              }
                              toUrl="/influencer/payment"
                            >
                              <InfluencerActivationSuccessPage />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/brands_wishlist"
                          element={<Company_list />}
                        />
                        <Route
                          path="/view_brands_list"
                          element={<Show_Company_List />}
                        />
                        <Route path="/brandDeals" element={<BrandDeals />} />
                        <Route
                          path="/brandCollabs"
                          element={<BrandCollabs />}
                        />
                        <Route path="/tools" element={<InfluencerTools />} />
                        <Route
                          path="/brandCollabs/details"
                          element={<BrandCollabsDetails />}
                        />
                        <Route path="/analytics" element={<Analytics />} />
                        <Route path="/wrapped2024" element={<YearWrap2024 />} />
                        <Route
                          path="/anchorWomans"
                          element={<WomenDayCard3DViewer />}
                        />
                        <Route path="/helpUs" element={<HelpUsPage />} />
                        <Route
                          path="/paymentDetails"
                          element={<InfluencerBankDetailsForm />}
                        />

                        {/* ------- connect app ---------- */}
                        {/* <Route
                          path="/apps"
                          element={<PlatformsIntegration />}
                        />
                        <Route
                          path="/app/youtube"
                          element={<YoutubeAnalyticsProfile />}
                        />
                        <Route
                          path="/app/x"
                          element={<TwitterAnalyticsProfile />}
                        />
                        <Route
                          path="/app/instagram"
                          element={<InstagramAnalyticsProfile />}
                        />
                        <Route
                          path="/app/linkedin"
                          element={<LinkedinAIExtV2 />}
                        /> */}

                        <Route
                          path="/boostVisibility"
                          element={
                            <ProtectedRoute
                              navigateCondition={!authState?.loggedUser?.slug}
                              toUrl="/influencer/dashboard"
                            >
                              <BoostVisibility />
                            </ProtectedRoute>
                          }
                        />
                        <Route path="/edit" element={<EditMediaKit />} />

                        <Route
                          path="/posts-performance"
                          element={<PostPerformance />}
                        />

                        <Route path="/wallet" element={<EarningWallet />} />
                      </>
                    )}
                  </Routes>
                </div>
              </section>
            </section>
          </div>
        )
        // )
        // : (
        //   <Routes>
        //     <Route path="*" element={<ScreenAlert />} />
        //   </Routes>
        // )
      }
    </>
  );
};

export default Home;
